// Shared toast helpers, styled to match the toasts ProjectPage already shows.
// The <Toaster /> is mounted once in App.js, so these can be called from
// anywhere — including outside React components.
import toast from "react-hot-toast";

const BASE = {
  style: { fontFamily: "Outfit, sans-serif" },
};

export const showSuccessToast = (message, options = {}) =>
  toast.success(message, {
    ...BASE,
    duration: 3000,
    style: { ...BASE.style, background: "#10B981", color: "#fff" },
    iconTheme: { primary: "#fff", secondary: "#10B981" },
    ...options,
  });

export const showErrorToast = (message, options = {}) =>
  toast.error(message, {
    ...BASE,
    duration: 4000,
    style: { ...BASE.style, background: "#EF4444", color: "#fff" },
    iconTheme: { primary: "#fff", secondary: "#EF4444" },
    ...options,
  });

export const showWarningToast = (message, options = {}) =>
  toast(message, {
    ...BASE,
    duration: 3500,
    icon: "⚠️",
    style: { ...BASE.style, background: "#F59E0B", color: "#fff" },
    ...options,
  });

// Shown when an org admin interacts with a project they can see for oversight
// but have not been given access to. A fixed toast id means mashing a locked
// cell replaces the existing toast instead of stacking a dozen of them.
// Shown when someone interacts with a project they can see but can't open.
// Points at the Request access button in the row rather than telling them to go
// find the owner themselves — that button now does the asking for them.
export const showNoAccessToast = (ownerName) => {
  const who = ownerName && ownerName !== "_" ? ownerName : "the owner";
  return showErrorToast(
    `You don't have access to this project. Use Request access to ask ${who} for it.`,
    { id: "project-no-access" }
  );
};

export default toast;
